import * as React from "react";
import styled from "styled-components";

import { Metrics, Palette } from "../../vars";

const MobileToolbarToggle: React.SFC<any> = ({ className, onClick }) => (
  <button className={className} onClick={onClick} aria-label="navigation" />
);

export default styled(MobileToolbarToggle)`
  border: none;
  background: none;
  height: 100%;
  line-height: ${Metrics.LineHeights.MOBILE_TOOLBAR_BUTTON}px;
  padding: 0 19px;
  margin-left: 64px;
  border-right: 1px solid ${Palette.Rebrand.Colours.G3};
  text-align: center;
  height: 64px;
  width: 64px;
  position: relative;

  &:before {
    position: absolute;
    content: "";
    top: 22px;
    left: 20px;
    width: 24px;
    height: 4px;
    border-top: 12px double ${Palette.Rebrand.Colours.G6};
    border-bottom: 4px solid ${Palette.Rebrand.Colours.G6};
  }

  .style--rebrand & {
    &:hover {
      &:before {
        border-color: ${Palette.Rebrand.Colours.P2};
      }
    }
  }
`;
